import { cn } from 'utils/cn';
import { t } from 'utils/getTranslations';

/**
 * A spinner centred over its nearest positioned ancestor. `static` in the `className` puts it back in
 * the flow instead, for a loader that sits in a list.
 *
 * The `CircularLoader` class is a targeting hook: a disabled button that shows this spinner keeps it
 * visible while dimming the rest of its content.
 */
export default function CircularLoader({ className }: { className?: string }) {
    return (
        <div
            className={cn(
                'CircularLoader absolute top-0 left-0 z-(--z-blocking-loader) flex size-full items-center justify-center',
                className
            )}
        >
            <span
                role="progressbar"
                aria-label={t('loading')}
                className="border-primary size-10 rounded-full border-[3px] border-t-transparent motion-safe:animate-spin motion-reduce:animate-pulse"
            />
        </div>
    );
}
